import { render, staticRenderFns } from "./FeaturedNewsItem.vue?vue&type=template&id=54aa17f4&scoped=true&"
import script from "./FeaturedNewsItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedNewsItem.vue?vue&type=style&index=0&id=54aa17f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa17f4",
  null
  
)

export default component.exports